module.exports = [
  { id: "c-t", value: "Templates" },
  { id: "c-fg", value: "Facilitation Guides" },
  { id: "c-lp", value: "Lesson Plans" },
  { id: "c-as", value: "Assessments" },
  { id: "c-w", value: "Webinars" },
  { id: "c-v", value: "Videos" },
  { id: "c-ar", value: "Articles" },
];
